module.exports = __webpack_public_path__ + "static/media/Twitter Squared.c20530fe.svg";